module.exports = __webpack_public_path__ + "img/hood height.e2ee86c1.png";